<div class="center-content-area">
    <h2 class="center-page-heading">{{ "profile_page_heading" | translate }}</h2>
    <p class="center-page-description">{{ "profile_page_description" | translate }}</p>
    <p-card class="md:mx-[-2rem]">
        <div class="mx-2 mt-2 mb-2">
            <h5>{{ "profile_profile_info_heading" | translate }}</h5>
            <p class="mb-12">{{ "profile_profile_info_description" | translate }}</p>
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 md:col-span-5">
                    <div class="w-full max-w-md">
                        <div class="flex flex-col gap-2 mb-4">
                            <label for="firstname">{{ "profile_firstname" | translate }}*</label>
                            <input id="firstname" type="text" pInputText [(ngModel)]="firstName" required #_firstName="ngModel" minlength="2" />
                            @if (_firstName.invalid && _firstName.touched) {
                                @if (_firstName.errors?.["required"]) {
                                    <p-message severity="error">
                                        {{ "standard_first_name_required" | translate }}
                                    </p-message>
                                }
                                @if (_firstName.errors?.["minlength"]) {
                                    <p-message severity="error">
                                        {{ "standard_charmin2" | translate }}
                                    </p-message>
                                }
                            }
                        </div>
                        <div class="flex flex-col gap-2">
                            <label for="lastname">{{ "profile_lastname" | translate }}*</label>
                            <input id="lastname" type="text" pInputText [(ngModel)]="lastName" required #_lastName="ngModel" minlength="2" />

                            @if (_lastName.invalid && _lastName.touched) {
                                @if (_lastName.errors?.["required"]) {
                                    <p-message severity="error">
                                        {{ "standard_last_name_required" | translate }}
                                    </p-message>
                                }
                                @if (_lastName.errors?.["minlength"]) {
                                    <p-message severity="error">
                                        {{ "standard_charmin2" | translate }}
                                    </p-message>
                                }
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify-start">
                <button
                    pButton
                    pRipple
                    type="button"
                    class="p-button-raised mr-2 mb-12"
                    data-testid="profile-save-name"
                    [disabled]="_firstName.invalid || _lastName.invalid"
                    (click)="saveProfile('name')"
                >
                    {{ "profile_button_save_profile_name" | translate }}
                </button>
            </div>
            <p-divider></p-divider>
            <h5>{{ "profile_language_heading" | translate }}</h5>
            <p class="mb-12">{{ "profile_language_description" | translate }}</p>
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 md:col-span-5">
                    <div class="w-full max-w-md">
                        <div class="flex flex-col gap-2">
                            <label for="dropdownLanguage">{{ "profile_language" | translate }}</label>
                            <p-select
                                inputId="dropdownLanguage"
                                [options]="languages"
                                [(ngModel)]="selectedLanguageCode"
                                optionLabel="name"
                                optionValue="code"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify-start">
                <button pButton pRipple type="button" class="p-button-raised mr-2 mb-12" data-testid="profile-save-language" (click)="saveProfile('language')">
                    {{ "profile_button_save_profile_language" | translate }}
                </button>
            </div>
            <p-divider></p-divider>
            <h5>{{ "profile_theme_heading" | translate }}</h5>
            <p class="mb-12">{{ "profile_theme_description" | translate }}</p>
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 md:col-span-5">
                    <div class="w-full max-w-md">
                        <div class="flex flex-col gap-2">
                            <label for="dropdownDisplay">{{ "profile_color" | translate }}</label>
                            <p-select inputId="dropdownDisplay" [options]="colors" [(ngModel)]="selectedColorCode" optionLabel="name" optionValue="code" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify-start">
                <button pButton pRipple type="button" class="p-button-raised mr-2 mb-12" data-testid="profile-save-theme" (click)="saveProfile('theme')">
                    {{ "profile_button_save_profile_theme" | translate }}
                </button>
            </div>
            <p-divider></p-divider>
            <h5>{{ "profile_date_time_settings_heading" | translate }}</h5>
            <p class="mb-12">{{ "profile_date_time_settings_description" | translate }}</p>
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 md:col-span-5">
                    <div class="w-full max-w-md">
                        <div class="flex flex-col gap-2 mb-4">
                            <label for="dropdownDateformat">{{ "profile_dateFormat" | translate }}</label>
                            <p-select
                                inputId="dropdownDateformat"
                                [options]="dateFormats"
                                [(ngModel)]="selectedDateFormatCode"
                                optionLabel="name"
                                optionValue="code"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 md:col-span-5">
                    <div class="w-full max-w-md">
                        <div class="flex flex-col gap-2">
                            <label for="dropdownTimeformat">{{ "profile_timeFormat" | translate }}</label>
                            <p-select
                                inputId="dropdownTimeformat"
                                [options]="timeFormats"
                                [(ngModel)]="selectedTimeFormatCode"
                                optionLabel="name"
                                optionValue="code"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify-start">
                <button pButton pRipple type="button" class="p-button-raised mr-2 mb-12" data-testid="profile-save-formats" (click)="saveProfile('formats')">
                    {{ "profile_button_save_profile_format" | translate }}
                </button>
            </div>
        </div>
    </p-card>

    <p-card class="md:mx-[-2rem] mt-8">
        <div class="mx-2 mt-12 mb-2">
            <h5>{{ "profile_email_heading" | translate }}</h5>
            <p class="mb-12">{{ "profile_email_description" | translate }}</p>
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 md:col-span-5">
                    <div class="w-full max-w-md">
                        <div class="flex flex-col gap-2">
                            <label for="email">{{ "profile_email" | translate }}*</label>
                            <input id="email" type="email" pInputText [(ngModel)]="email" #_email="ngModel" required [email]="true" />
                            <!-- pattern="^[a-zA-Z0-9.!#$%&'’*\-]+@[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]+)*$" -->
                        </div>

                        @if (_email.invalid && _email.touched) {
                            @if (_email.errors?.["required"]) {
                                <p-message class="mb-1" severity="error">
                                    {{ "standard_email_required" | translate }}
                                </p-message>
                            }
                            @if (_email.errors?.["email"]) {
                                <p-message class="mb-1" severity="error">
                                    {{ "standard_email_validation_error" | translate }}
                                </p-message>
                            }
                        }
                    </div>
                </div>
            </div>
            <div class="flex justify-start">
                <button
                    pButton
                    pRipple
                    type="button"
                    class="p-button-raised mr-2 mb-12"
                    data-testid="profile-change-email"
                    [disabled]="_email.invalid"
                    (click)="saveProfile('email')"
                >
                    {{ "profile_button_change_email_settings" | translate }}
                </button>
            </div>
        </div>
    </p-card>

    <p-card class="md:mx-[-2rem] mt-8">
        <div class="mx-2 mt-12 mb-2">
            <h5>{{ "profile_changepassword_heading" | translate }}</h5>
            <p class="mb-12">{{ "profile_changepassword_description" | translate }}</p>
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 md:col-span-5">
                    <div class="w-full max-w-md">
                        <div class="flex flex-col gap-2 mb-4">
                            <label for="changePassword">{{ "profile_password" | translate }}*</label>
                            <p-password id="changePassword" [(ngModel)]="changePassword" [toggleMask]="true" />
                        </div>

                        <div class="flex flex-col gap-2">
                            <label for="changePasswordRepeat">{{ "profile_passwordrepeat" | translate }}*</label>
                            <p-password id="changePasswordRepeat" [(ngModel)]="changePasswordRepeat" [toggleMask]="true" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify-start">
                <button
                    pButton
                    pRipple
                    type="button"
                    class="p-button-raised mr-2 mb-12"
                    data-testid="profile-change-password"
                    [disabled]="!changePassword || changePassword.length <= 6"
                    (click)="saveNewPassword()"
                >
                    {{ "nav_new_password" | translate }}
                </button>
            </div>
        </div>
    </p-card>
</div>
